// extracted by mini-css-extract-plugin
module.exports =  {"stars":"StarRater-YbzR__stars","star":"StarRater-_lWR__star","stars--medium":"StarRater-KWsZ__stars--medium","stars--small":"StarRater-uQ2y__stars--small"};